import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Acerca extends Component {
  componentDidMount() {
    window.startx();
  }
  render() {
    return (
      <div id="main" className="wrapper style1">
        <div className="container">
          <header className="major">
            <h2>Visita nuestra nueva Página Web</h2>
          </header>
          <div className="container">
            <span className="containerblog">
                <div className="align justify">
                    <h1>
                        Continuamos trabajando en nuestra nueva página web, donde podrás encontrar más información sobre el Museo Interactivo El Rehilete.
                    </h1>
                </div>
            </span>
    
              <div className="containerjuego">
                 <Link className="button" to="/">
                Haz click aquí para Ir al Sitio Principal
              </Link>
              </div>
            </div>
        </div>
      </div>
    );
  }
}

export default Acerca;